module.exports = __webpack_public_path__ + "img/BasicInfo3.b630a0ab.svg";